import { useState, useEffect, CSSProperties } from 'react';
import styles from './index.module.sass';
import iconArrow from '../../../../domain/assets/chevron-down.svg';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface SelectItem {
  key: string;
  name: string;
  disabled?: boolean;
}

interface FormSelectProps {
  label?: string;
  labelFor?: string;
  errorMessage?: string;
  defaultOption?: string;
  selectList: Array<SelectItem>;
  onSelect: (string: string) => void;
  option: string;
  style?: CSSProperties;
}

const FormSelect = ({
  label,
  labelFor,
  errorMessage,
  defaultOption = '',
  selectList,
  onSelect,
  option,
  style = {},
}: FormSelectProps) => {
  const [list, setList] = useState<Array<SelectItem>>([]);

  useEffect(() => {
    if (selectList) {
      if (defaultOption) {
        setList([{ key: 'default', name: defaultOption }].concat(selectList));
      } else {
        setList(selectList);
      }
    }
  }, [selectList]);

  const selectClass = cx({
    select: true,
    error: errorMessage,
  });

  const Error = () => {
    if (!errorMessage) return <></>;
    return <div className={styles['error-message']}>{errorMessage}</div>;
  };

  if (list.length === 0) return null;

  return (
    <div className={selectClass} style={style}>
      {label && (
        <label className={styles.label} htmlFor={labelFor}>
          {label}
        </label>
      )}
      <select
        id={labelFor}
        onChange={(e) => onSelect(e.target.value)}
        style={{
          background: `url(${iconArrow}) no-repeat calc(100% - 14px) center`,
          color: option === '' ? '#999999' : '#333333',
        }}
      >
        {list.map((item) => {
          const isDefaultItem = item.key === 'default';
          const selected = isDefaultItem ? option === '' : option === item.key;
          return (
            <option
              value={item.key}
              key={item.key}
              selected={selected}
              disabled={isDefaultItem || item.disabled}
            >
              {item.name}
            </option>
          );
        })}
      </select>
      <Error />
    </div>
  );
};

export default FormSelect;
